import { httpRequest } from "../../http";
import { LaunchAdSerializer } from "../../../models/serializers/launchAdSerializer.ts";

export class CommandGetEngagementAds {
  async run(engagementId: number) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/ads/`;
    const raw = await httpRequest<any[]>(url, { method: "GET" });
    return new LaunchAdSerializer().deserializeList(raw);
  }
}
